export const ControlLabel = ({ label, required }) => required ? <b>{label}<span style={{ color: "red"}}>{` *`}</span></b> : label;